import defaultImg from "assets/images/default-profile-picture.svg"
type Props = React.ImgHTMLAttributes<HTMLImageElement>

const PersonAvatar: React.FC<Props> = ({ src, alt, ...rest }) => {
  return (
    <img
      src={src ? src : defaultImg}
      alt={alt ? alt : ""}
      {...rest}
    />
  )
}

export default PersonAvatar
